










import Vue from 'vue'

export default Vue.extend({
  props: ['target'],
  computed: {
    listeners() {
      return this.$listeners
    },
  },
})
